/* eslint-disable max-len */
import { Latin } from '../core/languages/Latin';
import { Length, RubberLength } from '../gregorio-chant-svg-renderer/distances';

export class ChantContext {
  public debugMode = false;
  public debugGlyphs = false;

  public nabcLines = 1;
  public nabcMode: 'gall' | 'laon' = 'gall';
  public nabcOnlyParser = false;
  public nabcOnlyMode = false;
  public renderInteractiveElements = true;
  public scrollEnabled = true;
  public lineWidthPx = 800;
  public language = new Latin();
  public gabcFont = 'greciliae';
  public specialCharactersFont = 'greextra';

  public lyricTextFont = '\'Crimson Text\', serif';
  public lyricTextColor = '#000000';
  public gabcColor = '#000000';
  public staffLineColor = '#000000';
  public nabcColor = 'red';

  public dropCapTextSize = 64;
  public dropCapTextFont = this.lyricTextFont;
  public dropCapTextColor = this.lyricTextColor;

  // public commentaryPadding = 10;

  public nabcOnlyModeNabcLineBaselineY = 40;
  // public normalModeNabcLineBaselineY = 30;
  // public nabcLineHeight = 30;
  // public nabcLineInterval = 30;
  // public gabcLineInterval = 40;

  public annotationTextSize = 16;
  public annotationTextWeight = 600;
  public annotationTextFont = this.lyricTextFont;
  public annotationTextColor = this.lyricTextColor;

  // renderer constants 
  public staffLineWeight = 1;
  public chantLineTopPaddingPx = 36; // px
  public staffLineRightPaddingPx = 10; // px
  public lyricTextSizePx = 20; // px
  public interactiveElementsYPadding = 40;
  public commentaryraise = 10;

  // export variables 
  public pngQualityCoefficient = 10;

  // staffSize & computed
  public staffSize = 17; // 17

  public gabcGlyphSize = this.staffSize * 3; // px
  public nabcGlyphSize = this.staffSize * 0.9; // px
  public nabcLineHeight = this.staffSize * 0.9; // px

  public pitchHeight = 8.47; // px
  public pitchWidth = 8.47; // px
  public staffLinesInterval = this.staffSize * 0.48; // px
  public nabcVerticalInterval = this.staffSize * 0.10; // px

  // coefficients. experimentally determined
  public pxInCm = 55.22;
  public pxInEx = 9;
  public pxInPt = 1.3333333333333333;

  // P1
  public spaceabovelines = new Length(0, 'cm'); // space between lines
  public spacelinestext = new Length(3.48471, 'ex'); // space between staff lines and text
  public abovelinestextraise = new Length(-0.1, 'cm'); // space between staff line and nabc

  // P2
  public abovelinestextheight = new Length(0.3, 'cm');
  public alterationspace = new Length(0.07747, 'cm');
  public interglyphspace = new RubberLength(new Length(0.06927, 'cm'), new Length(0.00363, 'cm'), new Length(0.00363, 'cm'));
  public halfspace = new RubberLength(new Length(0.03464, 'cm'), new Length(0.00092, 'cm'), new Length(0.00182, 'cm'));
  public interelementspace = new RubberLength(new Length(0.06927, 'cm'), new Length(0.00182, 'cm'), new Length(0.00363, 'cm'));
  public largerspace = new RubberLength(new Length(0.10938, 'cm'), new Length(0.01822, 'cm'), new Length(0.00911, 'cm'));
  public glyphspace = new RubberLength(new Length(0.21877, 'cm'), new Length(0.01822, 'cm'), new Length(0.01822, 'cm'));
  public spacebeforesigns = new RubberLength(new Length(0.05, 'cm'), new Length(0.004, 'cm'), new Length(0.004, 'cm'));
  public spaceafterlineclef = new RubberLength(new Length(0.23, 'cm'), new Length(0, 'cm'), new Length(0.01367, 'cm'));
  public interwordspacenotes = new RubberLength(new Length(0.29, 'cm'), new Length(0.05, 'cm'), new Length(0.05, 'cm'));
  public interwordspacetext = new RubberLength(new Length(0.17, 'cm'), new Length(0.05, 'cm'), new Length(0.05, 'cm'));
  public bitrivirspace = new RubberLength(new Length(0.06927, 'cm'), new Length(0.00182, 'cm'), new Length(0.00546, 'cm'));
  public bitristrospace = new RubberLength(new Length(0.06927, 'cm'), new Length(0.00182, 'cm'), new Length(0.00546, 'cm'));
  public punctuminclinatumshift = new RubberLength(new Length(-0.03918, 'cm'), new Length(0.0009, 'cm'), new Length(0.0009, 'cm'));
  public punctuminclinatumunisonshift = new RubberLength(new Length(0.05286, 'cm'), new Length(0.00728, 'cm'), new Length(0.00455, 'cm'));
  public beforepunctainclinatashift = new RubberLength(new Length(0.05286, 'cm'), new Length(0.00728, 'cm'), new Length(0.00455, 'cm'));
  public punctuminclinatumanddebilisshift = new RubberLength(new Length(-0.02278, 'cm'), new Length(0.0009, 'cm'), new Length(0.0009, 'cm'));
  public punctuminclinatumdebilisshift = new RubberLength(new Length(-0.00728, 'cm'), new Length(0.0009, 'cm'), new Length(0.0009, 'cm'));
  public punctuminclinatumbigshift = new RubberLength(new Length(0.07565, 'cm'), new Length(0.0009, 'cm'), new Length(0.0009, 'cm'));
  public punctuminclinatummaxshift = new RubberLength(new Length(0.17865, 'cm'), new Length(0.0009, 'cm'), new Length(0.0009, 'cm'));
  public maximumspacewithoutdash = new Length(0, 'cm');
  public annotationseparation = new Length(0.05, 'cm');
  public annotationraise = new Length(-0.2, 'cm');
  public spacebeneathtext = new Length(0, 'cm');
  public nabcinterelementspace = new RubberLength(new Length(0.06927, 'cm'), new Length(0.00182, 'cm'), new Length(0.00363, 'cm'));
  public nabclargerspace = new RubberLength(new Length(0.10938, 'cm'), new Length(0.01822, 'cm'), new Length(0.00911, 'cm'));
  public clefchangespace = new RubberLength(new Length(0.27345, 'cm'), new Length(0.14584, 'cm'), new Length(0.01367, 'cm'));
  public divisiofinalissep = new Length(0.1094, 'cm');
  public linepunctummorashift = new Length(-0.06314, 'cm');
  public spacepunctummorashift = new Length(-0.02013, 'cm');
  public spaceamonepespunctummorashift = new Length(0.00183, 'cm');
  public lineporrectuspunctummorashift = new Length(0.04575, 'cm');
  public spaceporrectuspunctummorashift = new Length(0.00000, 'cm');

  // P3 
  public additionalcustoslineswidth = new Length(0.09114, 'cm');
  public additionallineswidth = new Length(0.14584, 'cm');
  public afterinitialshift = new Length(0.2, 'cm');
  public alterationadjustmentbar = new Length(0.07, 'cm');
  public ascendinginclinatumtonobarbigshift = new RubberLength(new Length(0.04427, 'cm'), new Length(0.00363, 'cm'), new Length(0.00363, 'cm'));
  public ascendinginclinatumtonobarmaxshift = new RubberLength(new Length(0.12927, 'cm'), new Length(0.00363, 'cm'), new Length(0.00363, 'cm'));
  public ascendinginclinatumtonobarshift = new RubberLength(new Length(-0.02473, 'cm'), new Length(0.00363, 'cm'), new Length(0.00363, 'cm'));
  public ascendingpunctuminclinatumanddebilisshift = new RubberLength(new Length(-0.02278, 'cm'), new Length(0.0009, 'cm'), new Length(0.0009, 'cm'));
  public ascendingpunctuminclinatumbigshift = new RubberLength(new Length(0.07565, 'cm'), new Length(0.0009, 'cm'), new Length(0.0009, 'cm'));
  public ascendingpunctuminclinatummaxshift = new RubberLength(new Length(0.17865, 'cm'), new Length(0.0009, 'cm'), new Length(0.0009, 'cm'));
  public ascendingpunctuminclinatumshift = new RubberLength(new Length(-0.03918, 'cm'), new Length(0.0009, 'cm'), new Length(0.0009, 'cm'));
  public bar_finalfinalis = new RubberLength(new Length(0.29169, 'cm'), new Length(0.07292, 'cm'), new Length(0.27345, 'cm'));
  public beforeinitialshift = new Length(0.2, 'cm');
  public clefflatspace = new RubberLength(new Length(0.05469, 'cm'), new Length(0.00638, 'cm'), new Length(0.00638, 'cm'));
  public descendinginclinatumtonobarbigshift = new RubberLength(new Length(0.10927, 'cm'), new Length(0.00363, 'cm'), new Length(0.00363, 'cm'));
  public descendinginclinatumtonobarmaxshift = new RubberLength(new Length(0.23927, 'cm'), new Length(0.00363, 'cm'), new Length(0.00363, 'cm'));
  public descendinginclinatumtonobarshift = new RubberLength(new Length(-0.00073, 'cm'), new Length(0.00363, 'cm'), new Length(0.00363, 'cm'));
  public hepisemamiddleshift = new Length(0.07206, 'cm');
  public initialraise = new Length(0, 'cm');
  public intersyllablespacenotes = new Length(0.24, 'cm');
  public intersyllablespacenotes_alteration = new Length(0.1, 'cm');
  public intersyllablespacestretchhyphen = new RubberLength(new Length(0, 'cm'), new Length(0.05, 'cm'));
  public interwordspacenotes_alteration = new RubberLength(new Length(0.1, 'cm'), new Length(0.07, 'cm'), new Length(0.01, 'cm'));
  public moraadjustment = new Length(0.05, 'cm');
  public moraadjustmentbar = new Length(0.050, 'cm');
  public notebarspace = new RubberLength(new Length(0.31903, 'cm'), new Length(0.27345, 'cm'), new Length(0.02824, 'cm'));
  public overhepisemahighshift = new Length(0.10066, 'cm');
  public overhepisemalowshift = new Length(0.02287, 'cm');
  public spaceaftersigns = new RubberLength(new Length(0.08203, 'cm'), new Length(0.0082, 'cm'), new Length(0.0082, 'cm'));
  public spacearoundclefbars = new RubberLength(new Length(0.03645, 'cm'), new Length(0.00455, 'cm'), new Length(0.0009, 'cm'));
  public spacebeforeeolcustos = new RubberLength(new Length(0.23, 'cm'), new Length(0, 'cm'), new Length(0, 'cm'));
  public spacebeforeinlinecustos = new RubberLength(new Length(0.10938, 'cm'), new Length(0.01822, 'cm'), new Length(0.00911, 'cm'));
  public textbartextspace = new RubberLength(new Length(0.24611, 'cm'), new Length(0.13672, 'cm'), new Length(0.04921, 'cm'));
  public underhepisemahighshift = new Length(0.10981, 'cm');
  public underhepisemalowshift = new Length(0.02763, 'cm');
  public uprightpunctuminclinatumshift = new RubberLength(new Length(0.05286, 'cm'), new Length(0.00728, 'cm'), new Length(0.00455, 'cm'));
  public vepisemahighshift = new Length(0.06634, 'cm');
  public vepisemalowshift = new Length(-0.01262, 'cm');
  public zerowidthspace = new Length(0, 'cm');

  // P4
  public descendingpunctuminclinatumascendingshift = new RubberLength(new Length(-0.07918, 'cm'), new Length(0.0009, 'cm'), new Length(0.0009, 'cm'));
  public ascendingpunctuminclinatumdescendingshift = new RubberLength(new Length(-0.07918, 'cm'), new Length(0.0009, 'cm'), new Length(0.0009, 'cm'));
}
